import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TableColumn } from '@ui/aos-lib';
import {
  MeterModel,
  Port,
  ServiceLocationIds
} from 'src/app/pages/equipment/field-operations/ui/field-operations.types';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @for (dataItem of data(); track $index) {
      <div class="f-center cell">
        <span>{{ dataItem.text }}</span>
      </div>
    }
  `,
  styles: `
    @use 'variables' as *;
    .cell + .cell {
      margin-top: 0.5rem;
    }
  `
})
export class MultiLineHighlightComponent {
  item = input.required<{ [key: string]: Port[] | ServiceLocationIds[] | MeterModel[] | null }>();
  column = input.required<TableColumn>();

  protected data = computed(() => {
    const items = this.item()[this.column().field] as Record<string, unknown>[] | null;

    if (!items) return [];

    return items.map(item => {
      const { ...rest } = item;
      const text = Object.values(rest)[0] ?? '';

      return { text };
    });
  });
}
